import { useState } from "react";
import { IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import { Loader } from "components";
import { useFeatureFlags } from "swing-components";

import { FilterBar } from "~components/Organisms/IndexFilters";
import { initialLocalStorageFilterValues } from "~components/Organisms/IndexFilters/types";
import { IndexSearch } from "~components/Organisms/IndexSearch";
import { translate, useLocalStorage } from "~utils";

import { useRequests } from "./hooks";
import { NoRequestsWithSearchTerm } from "./NoRequests";
import { RequestCount } from "./RequestCount";
import { RequestIndex } from "./RequestIndex";

export function PastRequestsPage() {
  const [ls, setLs] = useLocalStorage(
    "swing-schools:filters:past",
    initialLocalStorageFilterValues,
  );

  const [searchTerm, setSearchTerm] = useState("");

  const { flags } = useFeatureFlags();
  const showSearch = flags.adminIndexSearch;

  const { data, isFetching, isError } = useRequests({
    showHistory: true,
    filters: ls,
    searchTerm: showSearch ? searchTerm : undefined,
  });

  if (!data) return <Loader />;

  const { requests } = data;

  return (
    <>
      <IonHeader collapse="condense">
        <IonToolbar>
          <IonTitle size="large">{translate("ROUTE_TABLE_PAST_REQUESTS")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      {showSearch && <IndexSearch searchTerm={searchTerm} setSearchTerm={setSearchTerm} />}
      <FilterBar page="past" ls={ls} setLs={setLs} />
      {isFetching && searchTerm ? (
        <NoRequestsWithSearchTerm searchTerm={searchTerm} page="past" />
      ) : (
        <>
          <RequestCount page="past" count={data.total} />
          <RequestIndex
            requestType="past-requests"
            requests={requests}
            isError={isError}
            hasNextPage={data.hasNextPage}
            fetchNextPage={data.fetchNextPage}
            isFetchingNextPage={data.isFetchingNextPage}
          />
        </>
      )}
    </>
  );
}
